// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /pool/shared-with-account.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePoolSharedWithAccountBody,
  typePoolSharedWithAccountOutput200,
} from "../../sdk/pool/postPoolSharedWithAccount";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPoolSharedWithAccountQueryKey(
  payload: typePoolSharedWithAccountBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`accountId:${JSON.stringify(payload.accountId)}`);
  return [
    "post:pool:poolSharedWithAccount",
    "svc:pool-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePoolSharedWithAccountOutput200,
    unknown,
    typePoolSharedWithAccountOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePoolSharedWithAccount(
  payload: typePoolSharedWithAccountBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPoolSharedWithAccountQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPoolSharedWithAccount(payload),
    ...resolvedOptions,
  });
}
